<template>
  <v-menu ref="menu" offset-y>
    <template v-slot:activator="{ on, attrs }">
      <v-btn
        v-bind="attrs"
        v-on="on"
        plain
        text
        class="hyp-text-menu-btn pull-left"
      >
        {{ title }}:
        <span>{{ severityLevel.text }}</span>
        <v-icon right>
          mdi-menu-down
        </v-icon>
      </v-btn>
    </template>
    <v-container class="hyp-assets-filters-container">
      <v-list dense>
        <template v-for="(item, index) in items">
          <v-divider v-if="item.divider" :key="index"></v-divider>
          <v-list-item
            v-else
            :key="item.value"
            dense
            ripple
            @click="handleClick(item)"
          >
            <v-list-item-title
              >{{ item.text }} {{ item.label }}
            </v-list-item-title>
          </v-list-item>
        </template>
      </v-list>
    </v-container>
  </v-menu>
</template>
<script>
import { SEVERITY_LEVELS } from "@/common/constants/controlRisks/risks";

export default {
  name: "AssetSeveritySelector",
  props: {
    title: {
      type: String,
      required: true,
    },
    value: {
      type: String,
      default: "all",
    },
  },
  data() {
    return {
      items: SEVERITY_LEVELS,
      severityLevel: this.value ?? SEVERITY_LEVELS[0],
    };
  },
  methods: {
    handleClick(item) {
      this.severityLevel = item;
      this.$emit("input", item.value);
    },
  },
  watch: {
    value(val) {
      this.severityLevel = SEVERITY_LEVELS.find((level) => level.value === val);
    },
  },
};
</script>

<style scoped>
.hyp-text-menu-btn {
  border-radius: unset;
  border-bottom: 1px solid #aaaaaa;
  margin-top: 13px;
}

.hyp-assets-filters-container {
  background-color: white;
}
</style>
